"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpacingValue = void 0;
var _constants = require("../constants");
const getSpacingValue = slides => {
  if (typeof slides === 'object' && slides !== null) {
    const {
      spacing
    } = slides;
    if (typeof spacing === 'function') {
      return spacing();
    }
    return spacing ?? _constants.SPACING;
  }
  return _constants.SPACING;
};
exports.getSpacingValue = getSpacingValue;
